module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-stepper', {
    attrs: {
      "activeStep": _vm.activeStep
    }
  }, [_c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabYou')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabHealth')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabLocation')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabGoals')) + "\n      ")])], 1), _vm._v(" "), _c('mu-step', [_c('mu-step-label', [_vm._v("\n        " + _vm._s(_vm.$t('message.gettingStartedTabPersonalise')) + "\n      ")])], 1)], 1), _vm._v(" "), _c('mu-card', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }, [_c('mu-card-text', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/Dashboard.gif",
      "width": "25%"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n        " + _vm._s(_vm.$t('message.loadingText')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading && _vm.$store.state.list.diabetes_types),
      expression: "!isLoading && $store.state.list.diabetes_types"
    }]
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('div', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "70"
    }
  }, [(_vm.isDiabetic) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "diagnosisYearTxt",
      "data-vv-rules": 'required',
      "data-vv-name": "diagnosis_year",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountPreferencesDiagnosisYear'),
      "errorText": _vm.errors.first('diagnosis_year'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.accountPreferencesDiagnosisYear')
    },
    model: {
      value: (_vm.model.diagnosis_year),
      callback: function($$v) {
        _vm.$set(_vm.model, "diagnosis_year", $$v)
      },
      expression: "model.diagnosis_year"
    }
  }, _vm._l((_vm.yearList()), function(item, index) {
    return (_vm.moment(_vm.model.dob).format('Y') <= item) ? _c('mu-menu-item', {
      key: 'diagnosis-year-' + index,
      attrs: {
        "value": item,
        "title": item
      }
    }) : _vm._e()
  }), 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h2', {
    staticStyle: {
      "padding-top": "0",
      "margin-top": "0px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.gettingStartedHealthCheckRelevantBoxes')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "0",
      "padding-bottom": "0"
    }
  }, [_c('mu-checkbox', {
    attrs: {
      "id": "healthConditionChk",
      "label": _vm.isDiabetic ? _vm.$t('message.gettingStartedHealthDoYouHaveAnyOtherConditions') : _vm.$t('message.gettingStartedHealthDoYouHaveAnyConditions')
    },
    model: {
      value: (_vm.model.has_other_conditions),
      callback: function($$v) {
        _vm.$set(_vm.model, "has_other_conditions", $$v)
      },
      expression: "model.has_other_conditions"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.has_other_conditions),
      expression: "model.has_other_conditions"
    }]
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "conditions"
    }
  }, [_c('mu-auto-complete', {
    attrs: {
      "id": "conditionSearchingTxt",
      "scroller": _vm.scroller,
      "inputClass": "conSearchInput",
      "openOnFocus": !_vm.conditionSearching,
      "fullWidth": true,
      "hintText": _vm.conditionHelpText,
      "maxSearchResults": 10,
      "dataSource": _vm.conditionDataSource,
      "dataSourceConfig": _vm.conditionDataSourceConfig,
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleConditionSelected
    },
    model: {
      value: (_vm.conditionSearchValue),
      callback: function($$v) {
        _vm.conditionSearchValue = $$v
      },
      expression: "conditionSearchValue"
    }
  }), _vm._v(" "), (_vm.conditionSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "size": 16
    }
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _vm._l((_vm.model.user_conditions), function(item, index) {
    return _c('mu-chip', {
      key: 'condition-' + index
    }, [_c('mu-icon', {
      attrs: {
        "value": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleConditionRemoval(item)
        }
      }
    }), _vm._v("\n            " + _vm._s(item.condition_label) + "\n          ")], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder"
  })], 2), _vm._v(" "), _c('div', [_c('mu-checkbox', {
    attrs: {
      "id": "takesMedicationChk",
      "label": _vm.$t('message.accountPreferencesTakeMedication')
    },
    model: {
      value: (_vm.model.takes_medication),
      callback: function($$v) {
        _vm.$set(_vm.model, "takes_medication", $$v)
      },
      expression: "model.takes_medication"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.takes_medication),
      expression: "model.takes_medication"
    }]
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('div', {
    ref: "medications",
    staticClass: "mediSearch",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "medications"
    }
  }, [_c('mu-auto-complete', {
    attrs: {
      "id": "medicationSearchTxt",
      "scroller": _vm.scroller,
      "inputClass": "mediSearchInput",
      "openOnFocus": !_vm.medicationSearching,
      "dataSource": _vm.medicationDataSource,
      "dataSourceConfig": _vm.medicationDataSourceConfig,
      "fullWidth": true,
      "maxSearchResults": 10,
      "hintText": _vm.$t('message.gettingStartedHealthTypeMedication'),
      "maxHeight": 250,
      "filter": "noFilter"
    },
    on: {
      "change": _vm.handleMedicationSelected
    },
    model: {
      value: (_vm.medicationSearchValue),
      callback: function($$v) {
        _vm.medicationSearchValue = $$v
      },
      expression: "medicationSearchValue"
    }
  }), _vm._v(" "), (_vm.medicationSearching) ? _c('mu-circular-progress', {
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "height": "16px",
      "width": "16px"
    },
    attrs: {
      "size": 16
    }
  }) : _vm._e()], 1)])], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "100",
      "width": "100"
    }
  }, [(_vm.model.user_medications.length > 0) ? _c('mu-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.model.takes_medication),
      expression: "model.takes_medication"
    }],
    staticStyle: {
      "padding-bottom": "0",
      "padding-left": "0",
      "padding-right": "0"
    },
    attrs: {
      "id": "medication-list"
    }
  }, [_vm._l((_vm.model.user_medications), function(treatment, index) {
    return _c('mu-list-item', {
      key: 'treatment-' + index,
      staticStyle: {
        "padding-bottom": "0",
        "padding-left": "0",
        "padding-right": "0"
      },
      attrs: {
        "disableRipple": "",
        "title": treatment.treatment_name
      }
    }, [_c('mu-row', {
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "slot": "default",
        "gutter": ""
      },
      slot: "default"
    }, [_c('mu-col', {
      attrs: {
        "width": "50",
        "desktop": "70",
        "tablet": "50"
      }
    }, [_c('mu-select-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "id": "treatmentSelectTxt",
        "hintText": _vm.$t('message.selectText'),
        "data-vv-name": treatment.treatment_name + '_unit_' + index,
        "data-vv-rules": "required",
        "data-vv-value-as": "inputValue",
        "data-vv-validate-on": "none",
        "errorText": _vm.errors.first(treatment.treatment_name + '_unit_' + index),
        "maxHeight": 250,
        "fullWidth": "",
        "label": _vm.$t('message.labelUnits'),
        "autoWidth": ""
      },
      on: {
        "change": _vm.reformatMedications
      },
      model: {
        value: (treatment.unit_id),
        callback: function($$v) {
          _vm.$set(treatment, "unit_id", $$v)
        },
        expression: "treatment.unit_id"
      }
    }, _vm._l((_vm.medicationUnitRegimes), function(item, index) {
      return _c('mu-menu-item', {
        key: 'unit-regime-' + index,
        attrs: {
          "title": _vm.localizeRegime(item.unit_label),
          "value": item.unit_id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "50",
        "desktop": "30",
        "tablet": "50"
      }
    }, [_c('mu-select-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "id": "treatmentFrequencyTxt",
        "hintText": _vm.$t('message.selectText'),
        "data-vv-name": treatment.treatment_name + '_freq_' + index,
        "data-vv-rules": "required",
        "data-vv-value-as": "inputValue",
        "data-vv-validate-on": "none",
        "errorText": _vm.errors.first(treatment.treatment_name + '_freq_' + index),
        "maxHeight": 250,
        "fullWidth": "",
        "label": _vm.$t('message.labelHowOften'),
        "autoWidth": ""
      },
      on: {
        "change": _vm.reformatMedications
      },
      model: {
        value: (treatment.frequency_id),
        callback: function($$v) {
          _vm.$set(treatment, "frequency_id", $$v)
        },
        expression: "treatment.frequency_id"
      }
    }, _vm._l((_vm.medicationFrequencyRegimes), function(item, index) {
      return _c('mu-menu-item', {
        key: 'regime-frequency-' + index,
        attrs: {
          "title": _vm.$t(_vm.localizeFrequency(item.frequency_label)),
          "value": item.frequency_id
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('mu-icon', {
      attrs: {
        "slot": "right",
        "value": "delete"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleMedicationDeleted(treatment)
        }
      },
      slot: "right"
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "dashedBorder",
    staticStyle: {
      "margin-top": "8px"
    }
  })], 2) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.isDiabetic) ? _c('div', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('mu-checkbox', {
    attrs: {
      "id": "testBloodChk",
      "label": _vm.$t('message.accountPreferencesTestBlood')
    },
    model: {
      value: (_vm.model.tests_blood),
      callback: function($$v) {
        _vm.$set(_vm.model, "tests_blood", $$v)
      },
      expression: "model.tests_blood"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('mu-checkbox', {
    attrs: {
      "id": "smokesCigarettesChk",
      "label": _vm.$t('message.accountSmokesCigarettes')
    },
    model: {
      value: (_vm.model.smokes_cigarettes),
      callback: function($$v) {
        _vm.$set(_vm.model, "smokes_cigarettes", $$v)
      },
      expression: "model.smokes_cigarettes"
    }
  }), _vm._v(" "), (_vm.model.smokes_cigarettes) ? _c('div', [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "label": _vm.$t('message.accountCigarettesPerDay'),
      "type": "number",
      "data-vv-rules": 'required',
      "data-vv-name": "cigarettes_per_day",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.accountCigarettesPerDay'),
      "errorText": _vm.errors.first('cigarettes_per_day'),
      "underlineShow": _vm.underlineShow,
      "fullWidth": _vm.fullWidth,
      "maxHeight": 300,
      "hintText": _vm.$t('message.placeholderText')
    },
    model: {
      value: (_vm.model.cigarettes_per_day),
      callback: function($$v) {
        _vm.$set(_vm.model, "cigarettes_per_day", $$v)
      },
      expression: "model.cigarettes_per_day"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "submitBtn",
      "fullWidth": true,
      "secondary": "",
      "backgroundColor": "#9ACA3F",
      "color": "white",
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.nextText'),
      "disabled": _vm.isSaving
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d1d95ee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/GettingStarted/YourHealth.vue
// module id = 3770
// module chunks = 1